<template>
  <div>
    <v-card class="main-container">
        <v-card-text v-if="is_moderator">
          <v-row>
            <v-col cols="8">
              <div class="input-container input-name modal-mul-select">
                <v-select
                  v-model="section_id"
                  :items="all_sections"
                  item-text="name"
                  item-value="id"
                  label="Выберите мероприятие"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="4" class="mt-6">
              <template>
                <v-btn
                    @click="uploadToExcel()"
                    x-small style="margin-left: 15px;">
                    загрузить в * excel
                </v-btn>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <div class="input-container input-name modal-mul-select">
                <v-select
                  v-model="selected_date"
                  :items="all_dates"
                  item-text="name"
                  item-value="day"
                  label="Дата"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <!-- <v-row>
              <template>
                <BarChart :chartdata="chart_data" :options="options"/>
              </template>
          </v-row> -->

          <v-row>
            <v-data-table
                :style="{color: $mainColor}"
                :headers="headers"
                :items="listUsers"
                :loading="preloaderYet"
                loading-text="Загрузка списка ..."
                :items-per-page="50"
                :footer-props="{
                    itemsPerPageOptions: [20, 50, 200],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
              <template v-slot:item.created_at="{ item }">
                <p>{{  formate_datetime(item.created_at) }}</p>
              </template>

            </v-data-table>
          </v-row>
        </v-card-text>

    </v-card>

  </div>
</template>


<script>
  // import BarChart from './BarChart.vue'
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'UserAttendanceList',
    components: {
    },
    data() {
      return {
        listUsers: [],
        preloaderYet: false,

        is_moderator: false,
        section_id: 0,

        headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
            { text: 'Section', sortable: true, value: 'section_descr'},
            { text: 'created_at', sortable: true, value: 'created_at'},
        ],


        user_meeting_id: 3,
        all_sections: [],

        chart_data: {
          labels: [],
          datasets: [
            {
              label: '-',
              borderColor: '#77b7cd', // цвет линии
              pointBackgroundColor: '#77b7cd',
              // по умолчанию точки прозрачные, что не всегда красиво
              pointRadius: 4,
              data: []
            }
          ]
        },
        options: {
          responsive: true,
          /* график действительно адаптируется под мобильные экраны, но для более точной
          настройки приходится уточнить количество и точность подписей на осях */
          maintainAspectRatio: false,
          legend: {
            display: false // отключает легенду, бесполезную когда на графике одна линия
          },
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                precision: 2, // точность округления значений по оси y
                maxTicksLimit: 4 // максимальное количество значений (и рёбер сетки) по оси y
              }
            }],
            xAxes: [{
              display: true,
              ticks: {
                maxTicksLimit: 5 // максимальное количество значений (и рёбер сетки) по оси x
              }
            }]
          }
        },

        selected_date: null,
        all_dates: [
          {day: null, name: 'Все'},
          {day: '2025-10-22', name: '22.10.25'},
          {day: '2025-10-23', name: '23.10.25'},
          {day: '2025-10-24', name: '24.10.25'},
        ],

    };
    },
    beforeMount() {
      this.update_permissions()
    },
 
    computed: {
      ...mapGetters([
        'GETTERS_LOGIN',
        'GETTERS_CURRENT_USER',
        'GETTERS_SECTIONS',
      ]),
    },

    methods: {
      ...mapActions([
        'GET_ATTENDANCE_EXCEL_LIST',
        'GET_ATTENDANCE_LIST',
        'GET_CHART_DATA',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
      ]),


      update_permissions(){
        if (this.GETTERS_CURRENT_USER !== null) {
          try {
            for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
              const element = this.GETTERS_CURRENT_USER.role[index];

              if (element.access_rights == 'moderator' || element.access_rights == 'conf_admin') {
                this.is_moderator = true;
              }
            }

            if(!this.is_moderator)
              this.$router.push('/')
            else
            this.update_section_list()
              this.loadNewRequest();  
          } catch (ex) {
            console.log('ex ---> ', ex);
          }
        }
        else{
          this.$router.push('/')
        }
      },

      loadNewRequest(index = 0) {
        this.preloaderYet = true;
        this.listUsers = [];

        this.UPDATE_OVERLAY(true)
        this.GET_ATTENDANCE_LIST({type: 'attendance', section_id: this.section_id, selected_date: this.selected_date})
          .then((res) => {
            this.preloaderYet = false;
            this.listUsers = res;
            
            this.UPDATE_OVERLAY(false)
          })
          .catch(() => {
            this.UPDATE_OVERLAY(false)
            this.preloaderYet = false
          });
        
        this.chart_data.datasets.data = null;
        this.GET_CHART_DATA({type: 'attendance', section_id: this.section_id, selected_date: this.selected_date})
          .then((res) => {
            this.chart_data.datasets.data = res.y_array;
            this.chart_data.labels = res.x_array;
            console.log('CHART_DATA!!!', this.chart_data)
          })
          .catch(() => {
            this.UPDATE_OVERLAY(false)
          });
      },

      formate_datetime(val){
        var date_obj = new Date(val)
        var month = date_obj.getMonth() + 1
        var date = date_obj.getDate()
        var m = date_obj.getMinutes()
        var h = date_obj.getHours()
        if (h<10) h = '0'+h
        if (m<10) m = '0'+m
        if (month<10) month = '0' + month
        if (date<10) date = '0' + date

        return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
      },

      update_section_list(){
        this.all_sections = [{id: 0, name: 'Все'}]
        this.GETTERS_SECTIONS.forEach((item) => {
            this.all_sections.push(item)
        })

      },

      uploadToExcel() {
        this.UPDATE_OVERLAY(true)
        this.GET_ATTENDANCE_EXCEL_LIST({type: 'attendance', section_id: this.section_id})
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            window.open(res.url, '_blank');
          })
          .catch((e) => {
            this.UPDATE_OVERLAY(false)
          });
      },

    },

    watch: {
      section_id(val){
        this.loadNewRequest()
      },

      selected_date(val){
        this.loadNewRequest()
      },

      GETTERS_SECTIONS(val) {
        this.update_section_list()
      },

      GETTERS_CURRENT_USER(val){
        this.update_permissions()
      },
    },
  };

</script>
